// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/submission_management_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionKind, PlanSubmissionStatus, PlanTimeframe } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { ProcurementPlanReceptionError, ProcurementPlanSubmitErrorCategory } from "./procurement_plan_model_pb";
import { file_bffuser_v1_procurement_plan_model } from "./procurement_plan_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/submission_management_model.proto.
 */
export const file_bffuser_v1_submission_management_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bffuser_v1_procurement_plan_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * SubmissionDashboardArea is one area that has at least one demand-
 * procurement plan record (需要調達計画マスタ) registered, regardless of its
 * valid period, together with the cards valid on the requested target date.
 *
 * @generated from message bffuser.v1.SubmissionDashboardArea
 */
export type SubmissionDashboardArea = Message<"bffuser.v1.SubmissionDashboardArea"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Cards that have at least one plan record valid on the target date, in
   * PlanTypeCardKind order. Empty when no record of this area is valid on
   * the target date.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCard cards = 2;
   */
  cards: PlanTypeCard[];

  /**
   * Tab indicator summary of this area on the target date
   * (submission-management.md §3, AC-PSM-013 / 014 / 015). Always set, also
   * when cards is empty (all counts are then zero).
   *
   * @generated from field: bffuser.v1.SubmissionDashboardTabIndicator tab_indicator = 3;
   */
  tabIndicator?: SubmissionDashboardTabIndicator;

  /**
   * Number of cards per 提出ステータスの絞込 option on the target date
   * (submission-management.md §8, AC-PSM-073), over the cards' 代表の計画
   * only. Always set, also when cards is empty (all counts are then zero).
   *
   * @generated from field: bffuser.v1.SubmissionStatusFilterCounts submission_status_filter_counts = 4;
   */
  submissionStatusFilterCounts?: SubmissionStatusFilterCounts;
};

/**
 * Describes the message bffuser.v1.SubmissionDashboardArea.
 * Use `create(SubmissionDashboardAreaSchema)` to create a new message.
 */
export const SubmissionDashboardAreaSchema: GenMessage<SubmissionDashboardArea> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 0);

/**
 * SubmissionStatusFilterCounts counts the cards of an area that fall into
 * each 提出ステータスの絞込 option (AC-PSM-073). A card whose 代表の計画 has
 * no plan submission yet (SUBMISSION_STATUS_FILTER_NOT_CREATED) is in none
 * of the four 区分 but is counted in all.
 *
 * @generated from message bffuser.v1.SubmissionStatusFilterCounts
 */
export type SubmissionStatusFilterCounts = Message<"bffuser.v1.SubmissionStatusFilterCounts"> & {
  /**
   * 要対応.
   *
   * @generated from field: int32 action_required = 1;
   */
  actionRequired: number;

  /**
   * 未提出. Always equals SubmissionDashboardTabIndicator.unsubmitted_plan_count
   * (AC-PSM-073).
   *
   * @generated from field: int32 unsubmitted = 2;
   */
  unsubmitted: number;

  /**
   * 待ち.
   *
   * @generated from field: int32 waiting = 3;
   */
  waiting: number;

  /**
   * 提出済.
   *
   * @generated from field: int32 submitted = 4;
   */
  submitted: number;

  /**
   * すべて: every card of the area, including the NOT_CREATED ones.
   *
   * @generated from field: int32 all = 5;
   */
  all: number;
};

/**
 * Describes the message bffuser.v1.SubmissionStatusFilterCounts.
 * Use `create(SubmissionStatusFilterCountsSchema)` to create a new message.
 */
export const SubmissionStatusFilterCountsSchema: GenMessage<SubmissionStatusFilterCounts> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 1);

/**
 * SubmissionDashboardTabIndicator counts the plan records (計画単位) of an
 * area on the target date that need attention — only the cards' 代表の計画
 * (spec §2 / AC-PSM-048), never the other records — one field per indicator kind
 * (judged independently and overlaid). 計画内不整合 is
 * internal_inconsistency_plan_count; 計画間不整合 (#9599) and unhandled
 * congestion notices are not carried yet.
 *
 * @generated from message bffuser.v1.SubmissionDashboardTabIndicator
 */
export type SubmissionDashboardTabIndicator = Message<"bffuser.v1.SubmissionDashboardTabIndicator"> & {
  /**
   * Plan records whose representative plan submission (the same one
   * PlanTypeCardSubmissionSummary aggregates: the greatest version among the
   * target date's daily-timeframe plan submissions of the plan, #9242)
   * is GENERATED or EDITING (提出ステータス「未提出」). Plan records without any
   * plan submission are not counted.
   *
   * @generated from field: int32 unsubmitted_plan_count = 1;
   */
  unsubmittedPlanCount: number;

  /**
   * Plan records with an unresolved counterparty mismatch (取引相手間ミスマッチ,
   * submission-management.md §7「未解消」, AC-PSM-048): the latest registered
   * daily plan submission (the latest ACCEPTED or INCONSISTENT one by version,
   * across daily timeframes) is INCONSISTENT and one of its mismatch notices
   * has not been resolved, regardless of the representative plan submission's
   * status. A resolved plan is not counted.
   * Deprecated: counts only 取引相手間ミスマッチ. Use
   * counterparty_mismatch_or_rejected_plan_count (AC-PSM-013 @ b4a5e04d52).
   * Still populated for old frontends during staged rollout.
   *
   * @generated from field: int32 counterparty_mismatch_plan_count = 2 [deprecated = true];
   * @deprecated
   */
  counterpartyMismatchPlanCount: number;

  /**
   * Plan records with an unresolved counterparty mismatch (as
   * counterparty_mismatch_plan_count), OR whose representative plan submission
   * is REJECTED (タブインジケータ「取引相手間ミスマッチ・差戻し」, AC-PSM-013).
   * Each plan record counts once.
   *
   * @generated from field: int32 counterparty_mismatch_or_rejected_plan_count = 3;
   */
  counterpartyMismatchOrRejectedPlanCount: number;

  /**
   * Plan records whose 需要調達計画 has a 計画内不整合 (plan-common.md AC-IC-005 /
   * 006) on the version the plan list 整合ステータス also judges: the greatest
   * daily-timeframe version that is neither GENERATING nor GENERATION_FAILED.
   * A plan record without such a version is not counted (タブインジケータ
   * 「計画内・計画間不整合」, AC-PSM-013; P0' judges 計画内不整合 only, and
   * where 計画間不整合 is carried is decided with #9599).
   *
   * @generated from field: int32 internal_inconsistency_plan_count = 4;
   */
  internalInconsistencyPlanCount: number;
};

/**
 * Describes the message bffuser.v1.SubmissionDashboardTabIndicator.
 * Use `create(SubmissionDashboardTabIndicatorSchema)` to create a new message.
 */
export const SubmissionDashboardTabIndicatorSchema: GenMessage<SubmissionDashboardTabIndicator> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 2);

/**
 * PlanTypeCard is one plan-type card and the plan records it covers.
 *
 * @generated from message bffuser.v1.PlanTypeCard
 */
export type PlanTypeCard = Message<"bffuser.v1.PlanTypeCard"> & {
  /**
   * @generated from field: bffuser.v1.PlanTypeCardKind kind = 1;
   */
  kind: PlanTypeCardKind;

  /**
   * The card's 代表の計画 (spec submission-management §2): among the plan
   * records (需要調達計画マスタ) classified into this card and valid on the
   * target date, the one with the smallest code. Always exactly one element;
   * the others are not on the dashboard (each plan list shows every record).
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardPlanRecord plan_records = 2;
   */
  planRecords: PlanTypeCardPlanRecord[];

  /**
   * Header submission status of the card (AC-PSM-008 / 009 / 010 / 053).
   * Always set.
   *
   * @generated from field: bffuser.v1.PlanTypeCardSubmissionSummary submission_summary = 3;
   */
  submissionSummary?: PlanTypeCardSubmissionSummary;

  /**
   * 提出ステータスの絞込 option of the card's 代表の計画 for the viewer
   * (AC-PSM-071 / 072). Always set (never UNSPECIFIED).
   *
   * @generated from field: bffuser.v1.SubmissionStatusFilter submission_status_filter = 4;
   */
  submissionStatusFilter: SubmissionStatusFilter;
};

/**
 * Describes the message bffuser.v1.PlanTypeCard.
 * Use `create(PlanTypeCardSchema)` to create a new message.
 */
export const PlanTypeCardSchema: GenMessage<PlanTypeCard> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 3);

/**
 * PlanTypeCardPlanRecord references one plan record under a card, together
 * with its representative plan submission and its counterparty cards
 * (取引先カード, submission-management.md §6).
 *
 * @generated from message bffuser.v1.PlanTypeCardPlanRecord
 */
export type PlanTypeCardPlanRecord = Message<"bffuser.v1.PlanTypeCardPlanRecord"> & {
  /**
   * @generated from field: string demand_procurement_master_id = 1;
   */
  demandProcurementMasterId: string;

  /**
   * Representative BG code of the plan record (= OCCTO submission entity
   * code of its plans).
   *
   * @generated from field: string representative_bg_code = 2;
   */
  representativeBgCode: string;

  /**
   * ID of the plan record's representative plan submission on the target date
   * (the same one PlanTypeCardSubmissionSummary aggregates: the greatest
   * version among the target date's daily-timeframe plan submissions); its
   * counterparty cards link to that version's detail. Absent when the plan
   * record has no plan submission: its counterparty cards then link to the
   * detail of the plan with no submission record (GetNoSubmissionRecordPlan)
   * when the card's submission_summary.no_submission_record is set, and to no
   * detail otherwise.
   *
   * @generated from field: optional string representative_plan_submission_id = 3;
   */
  representativePlanSubmissionId?: string;

  /**
   * Counterparty cards grouped by member business (所属事業者: every member of
   * the representative BG, the representative business included). A single
   * block without constituent when the plan record is not split (fewer than
   * two members, or a battery card). Always non-empty.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardPartnerBlock partner_blocks = 4;
   */
  partnerBlocks: PlanTypeCardPartnerBlock[];
};

/**
 * Describes the message bffuser.v1.PlanTypeCardPlanRecord.
 * Use `create(PlanTypeCardPlanRecordSchema)` to create a new message.
 */
export const PlanTypeCardPlanRecordSchema: GenMessage<PlanTypeCardPlanRecord> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 4);

/**
 * PlanTypeCardPartnerBlock is the procurement side / sales side two-column
 * block of counterparty cards (AC-PSM-033), for one member business
 * (所属事業者) when the plan record is split.
 *
 * @generated from message bffuser.v1.PlanTypeCardPartnerBlock
 */
export type PlanTypeCardPartnerBlock = Message<"bffuser.v1.PlanTypeCardPartnerBlock"> & {
  /**
   * Set only when the plan record is split by member business (所属事業者).
   *
   * @generated from field: optional bffuser.v1.PlanTypeCardConstituent constituent = 1;
   */
  constituent?: PlanTypeCardConstituent;

  /**
   * Counterparty cards of the procurement side (調達側), in display order.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardPartner procurement_partners = 2;
   */
  procurementPartners: PlanTypeCardPartner[];

  /**
   * Counterparty cards of the sales side (販売側), in display order.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardPartner sales_partners = 3;
   */
  salesPartners: PlanTypeCardPartner[];
};

/**
 * Describes the message bffuser.v1.PlanTypeCardPartnerBlock.
 * Use `create(PlanTypeCardPartnerBlockSchema)` to create a new message.
 */
export const PlanTypeCardPartnerBlockSchema: GenMessage<PlanTypeCardPartnerBlock> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 5);

/**
 * PlanTypeCardConstituent is one member business (所属事業者) of the plan
 * record's representative BG.
 *
 * @generated from message bffuser.v1.PlanTypeCardConstituent
 */
export type PlanTypeCardConstituent = Message<"bffuser.v1.PlanTypeCardConstituent"> & {
  /**
   * @generated from field: string business_code = 1;
   */
  businessCode: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message bffuser.v1.PlanTypeCardConstituent.
 * Use `create(PlanTypeCardConstituentSchema)` to create a new message.
 */
export const PlanTypeCardConstituentSchema: GenMessage<PlanTypeCardConstituent> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 6);

/**
 * PlanTypeCardPartner is one counterparty card (取引先カード).
 *
 * @generated from message bffuser.v1.PlanTypeCardPartner
 */
export type PlanTypeCardPartner = Message<"bffuser.v1.PlanTypeCardPartner"> & {
  /**
   * @generated from field: bffuser.v1.PlanTypeCardPartnerKind kind = 1;
   */
  kind: PlanTypeCardPartnerKind;

  /**
   * Counterparty code (JSPT3 / J1HR3 for JEPX). Used as the `partner` query
   * parameter of the plan detail deep link (AC-PSM-038-1).
   *
   * @generated from field: string counterparty_code = 2;
   */
  counterpartyCode: string;

  /**
   * Resolved display name. Absent for JEPX (the client renders a fixed label)
   * and when no name can be resolved (the client shows the code only).
   * Counterparties follow the procurement plan detail rule: trading partner
   * short name, "—" when ambiguous, otherwise (unregistered) the contract's
   * counterparty name for a contract counterparty, or the master code name
   * for a self-wheeling / battery card's master code. Internal codes use the
   * master code name.
   *
   * @generated from field: optional string display_name = 3;
   */
  displayName?: string;

  /**
   * Submission state (提出状態) of this card against the counterparty
   * (AC-PSM-034 / 035 / 036). UNSPECIFIED means the state cannot be judged
   * (no OCCTO-registered daily section, the adopted inconsistency notice
   * does not identify counterparties on this side, or the plan's
   * counterparty mismatch was resolved and this counterparty is one the
   * notice marked) and the client shows no state rather than "一致".
   *
   * @generated from field: bffuser.v1.PlanTypeCardPartnerSubmissionState submission_state = 4;
   */
  submissionState: PlanTypeCardPartnerSubmissionState;

  /**
   * Mismatches found for this card, one element per mismatch kind
   * (AC-IC-003: kinds are judged independently and overlaid). Non-empty iff
   * submission_state is MISMATCH.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardPartnerMismatch mismatches = 5;
   */
  mismatches: PlanTypeCardPartnerMismatch[];
};

/**
 * Describes the message bffuser.v1.PlanTypeCardPartner.
 * Use `create(PlanTypeCardPartnerSchema)` to create a new message.
 */
export const PlanTypeCardPartnerSchema: GenMessage<PlanTypeCardPartner> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 7);

/**
 * PlanTypeCardPartnerMismatch is one kind of mismatch on a counterparty card.
 *
 * @generated from message bffuser.v1.PlanTypeCardPartnerMismatch
 */
export type PlanTypeCardPartnerMismatch = Message<"bffuser.v1.PlanTypeCardPartnerMismatch"> & {
  /**
   * @generated from field: bffuser.v1.PlanTypeCardMismatchKind kind = 1;
   */
  kind: PlanTypeCardMismatchKind;

  /**
   * Mismatched koma ranges, ascending, consecutive koma merged (AC-IC-002).
   * Empty when the source does not identify koma.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardKomaRange ranges = 2;
   */
  ranges: PlanTypeCardKomaRange[];

  /**
   * Plan submission the mismatch was detected on. The client attaches the
   * highlight query only when this equals the record's representative plan
   * submission (AC-PSM-038-1).
   *
   * @generated from field: string plan_submission_id = 3;
   */
  planSubmissionId: string;

  /**
   * The mismatch comes from an OCCTO inconsistency notice with no matching
   * eBalance plan submission (AC-PSM-078); plan_submission_id is empty. The
   * client attaches the highlight query to whichever plan detail it opens
   * (AC-PSM-038-1).
   *
   * @generated from field: bool from_unmatched_notice = 4;
   */
  fromUnmatchedNotice: boolean;
};

/**
 * Describes the message bffuser.v1.PlanTypeCardPartnerMismatch.
 * Use `create(PlanTypeCardPartnerMismatchSchema)` to create a new message.
 */
export const PlanTypeCardPartnerMismatchSchema: GenMessage<PlanTypeCardPartnerMismatch> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 8);

/**
 * PlanTypeCardKomaRange is an inclusive range of koma numbers (1..48).
 *
 * @generated from message bffuser.v1.PlanTypeCardKomaRange
 */
export type PlanTypeCardKomaRange = Message<"bffuser.v1.PlanTypeCardKomaRange"> & {
  /**
   * @generated from field: int32 from_koma = 1;
   */
  fromKoma: number;

  /**
   * @generated from field: int32 to_koma = 2;
   */
  toKoma: number;
};

/**
 * Describes the message bffuser.v1.PlanTypeCardKomaRange.
 * Use `create(PlanTypeCardKomaRangeSchema)` to create a new message.
 */
export const PlanTypeCardKomaRangeSchema: GenMessage<PlanTypeCardKomaRange> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 9);

/**
 * PlanTypeCardSubmissionSummary aggregates the card's representative plan
 * submissions: for each plan record, the greatest-version plan submission
 * among the target date's daily timeframes (当日 / 翌日 / 翌々日 are one plan,
 * #9242). A plan record without any plan
 * submission counts as UNSUBMITTED, except one that shows an inconsistency
 * notice with no matching version (AC-PSM-078): it contributes no main badge
 * (no_submission_record).
 *
 * @generated from message bffuser.v1.PlanTypeCardSubmissionSummary
 */
export type PlanTypeCardSubmissionSummary = Message<"bffuser.v1.PlanTypeCardSubmissionSummary"> & {
  /**
   * @generated from field: bffuser.v1.PlanTypeCardProgressStage progress_stage = 1;
   */
  progressStage: PlanTypeCardProgressStage;

  /**
   * Any plan record's latest registered daily plan submission (the latest
   * ACCEPTED or INCONSISTENT one by version, across daily timeframes) is
   * INCONSISTENT (不整合 badge), regardless of the representative plan
   * submission's status, or a plan record without any registered daily plan
   * submission shows an inconsistency notice with no matching version
   * (AC-PSM-078). Either stays true after the mismatch is resolved.
   *
   * @generated from field: bool has_inconsistent = 2;
   */
  hasInconsistent: boolean;

  /**
   * @generated from field: bffuser.v1.PlanTypeCardAttention attention = 3;
   */
  attention: PlanTypeCardAttention;

  /**
   * Greatest submitted_at over every version of the target date's 単日 plans
   * of the card's plan records (not only the representatives). Absent when
   * none has been submitted.
   *
   * @generated from field: optional google.protobuf.Timestamp last_submitted_at = 4;
   */
  lastSubmittedAt?: Timestamp;

  /**
   * One entry per representative plan submission in an error status, in
   * plan record order.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardSubmissionError errors = 5;
   */
  errors: PlanTypeCardSubmissionError[];

  /**
   * Any representative plan submission is APPROVAL_PENDING (承認待ちバッジ).
   *
   * @generated from field: bool has_approval_pending = 6;
   */
  hasApprovalPending: boolean;

  /**
   * Any representative plan submission is SUBMITTING (処理中バッジ).
   *
   * @generated from field: bool has_submitting = 7;
   */
  hasSubmitting: boolean;

  /**
   * The card's 代表の計画 has a 計画内不整合 (plan-common.md AC-IC-005 / 006) on
   * the version the plan list 整合ステータス also judges (the greatest daily
   * version that is neither GENERATING nor GENERATION_FAILED). Shown as a
   * badge overlaid on the submission status badges (AC-PSM-077); independent
   * of has_inconsistent and attention. Counterparty cards never show it.
   *
   * @generated from field: bool has_internal_inconsistency = 8;
   */
  hasInternalInconsistency: boolean;

  /**
   * The card's 代表の計画 has no eBalance plan submission and shows an OCCTO
   * inconsistency notice with no matching version (AC-PSM-078): show 「eBalance
   * での提出記録なし」 in the last-submitted field and no main badge
   * (progress_stage is UNSPECIFIED only in this case). has_inconsistent is true.
   *
   * @generated from field: bool no_submission_record = 9;
   */
  noSubmissionRecord: boolean;
};

/**
 * Describes the message bffuser.v1.PlanTypeCardSubmissionSummary.
 * Use `create(PlanTypeCardSubmissionSummarySchema)` to create a new message.
 */
export const PlanTypeCardSubmissionSummarySchema: GenMessage<PlanTypeCardSubmissionSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 10);

/**
 * PlanTypeCardSubmissionError is one error row of the card header.
 *
 * @generated from message bffuser.v1.PlanTypeCardSubmissionError
 */
export type PlanTypeCardSubmissionError = Message<"bffuser.v1.PlanTypeCardSubmissionError"> & {
  /**
   * Representative BG code of the plan record the plan submission belongs to.
   *
   * @generated from field: string representative_bg_code = 1;
   */
  representativeBgCode: string;

  /**
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 2;
   */
  timeframe: PlanTimeframe;

  /**
   * REJECTED / GENERATION_FAILED / SUBMIT_FAILED / SEND_FAILED.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 3;
   */
  status: PlanSubmissionStatus;

  /**
   * Same read-time classification as the procurement plan list.
   *
   * @generated from field: bffuser.v1.ProcurementPlanSubmitErrorCategory error_category = 4;
   */
  errorCategory: ProcurementPlanSubmitErrorCategory;

  /**
   * OCCTO reception errors (REJECTED only, when available).
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanReceptionError reception_errors = 5;
   */
  receptionErrors: ProcurementPlanReceptionError[];

  /**
   * PlanSubmissionDetailView.credential_rejection_result_codes と同じ値
   * (AC-PSM-053 のカードの 1 文に出す)。
   *
   * @generated from field: repeated string credential_rejection_result_codes = 6;
   */
  credentialRejectionResultCodes: string[];

  /**
   * error_category = BREAKDOWN_LIMIT_EXCEEDED の時だけ、作成失敗した時点の内訳件数の
   * 上限値 (AC-PLC-064)。internalapi.v1.PlanTypeCardSubmissionError.breakdown_row_limit
   * の pass-through。
   *
   * @generated from field: optional int32 breakdown_row_limit = 7;
   */
  breakdownRowLimit?: number;
};

/**
 * Describes the message bffuser.v1.PlanTypeCardSubmissionError.
 * Use `create(PlanTypeCardSubmissionErrorSchema)` to create a new message.
 */
export const PlanTypeCardSubmissionErrorSchema: GenMessage<PlanTypeCardSubmissionError> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 11);

/**
 * PlanCounterpartyMismatchPartner is one counterparty × side of a plan's
 * unresolved counterparty mismatch (the resolve dialog's list, AC-PSM-064).
 *
 * @generated from message bffuser.v1.PlanCounterpartyMismatchPartner
 */
export type PlanCounterpartyMismatchPartner = Message<"bffuser.v1.PlanCounterpartyMismatchPartner"> & {
  /**
   * @generated from field: string counterparty_code = 1;
   */
  counterpartyCode: string;

  /**
   * Trading-partner-master short name, or the name the OCCTO notice carries.
   * Absent when neither is known (show the code).
   *
   * @generated from field: optional string counterparty_name = 2;
   */
  counterpartyName?: string;

  /**
   * @generated from field: bffuser.v1.PlanCounterpartyMismatchSide side = 3;
   */
  side: PlanCounterpartyMismatchSide;

  /**
   * Mismatched koma ranges, ascending, consecutive koma merged. Empty when
   * the notice does not identify koma.
   *
   * @generated from field: repeated bffuser.v1.PlanTypeCardKomaRange ranges = 4;
   */
  ranges: PlanTypeCardKomaRange[];
};

/**
 * Describes the message bffuser.v1.PlanCounterpartyMismatchPartner.
 * Use `create(PlanCounterpartyMismatchPartnerSchema)` to create a new message.
 */
export const PlanCounterpartyMismatchPartnerSchema: GenMessage<PlanCounterpartyMismatchPartner> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 12);

/**
 * PlanCounterpartyMismatchResolution is a plan's last resolution record.
 *
 * @generated from message bffuser.v1.PlanCounterpartyMismatchResolution
 */
export type PlanCounterpartyMismatchResolution = Message<"bffuser.v1.PlanCounterpartyMismatchResolution"> & {
  /**
   * Member id of the last resolver (resolve the display name through
   * UserDirectoryService).
   *
   * @generated from field: string resolved_by = 1;
   */
  resolvedBy: string;

  /**
   * When the last resolution was recorded.
   *
   * @generated from field: google.protobuf.Timestamp resolved_at = 2;
   */
  resolvedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.PlanCounterpartyMismatchResolution.
 * Use `create(PlanCounterpartyMismatchResolutionSchema)` to create a new message.
 */
export const PlanCounterpartyMismatchResolutionSchema: GenMessage<PlanCounterpartyMismatchResolution> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 13);

/**
 * PlanHandlingMemo is one 対応メモ of a plan (submission-management.md §7,
 * AC-PSM-068): an append-only note that is never edited nor deleted
 * (AC-PSM-061). Every version of the plan reads the same history.
 *
 * @generated from message bffuser.v1.PlanHandlingMemo
 */
export type PlanHandlingMemo = Message<"bffuser.v1.PlanHandlingMemo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Body with the surrounding white space removed (1..100 code points).
   *
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * Member id of the poster (resolve the display name through
   * UserDirectoryService).
   *
   * @generated from field: string posted_by = 3;
   */
  postedBy: string;

  /**
   * When the memo was recorded (server time).
   *
   * @generated from field: google.protobuf.Timestamp posted_at = 4;
   */
  postedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.PlanHandlingMemo.
 * Use `create(PlanHandlingMemoSchema)` to create a new message.
 */
export const PlanHandlingMemoSchema: GenMessage<PlanHandlingMemo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 14);

/**
 * SubmissionManagementPlanKey is the business key of one 単日 plan (計画の識別:
 * 計画種別 × 対象日 × エリア × 計画提出者コード). The area is the trailing digit of
 * submission_entity_code. Only DEMAND_PROCUREMENT is accepted today
 * (INVALID_ARGUMENT otherwise); 0151 / 0111 plans join with AC-PSM-076 [P1].
 *
 * @generated from message bffuser.v1.SubmissionManagementPlanKey
 */
export type SubmissionManagementPlanKey = Message<"bffuser.v1.SubmissionManagementPlanKey"> & {
  /**
   * @generated from field: bfftypes.v1.PlanSubmissionKind kind = 1;
   */
  kind: PlanSubmissionKind;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: string submission_entity_code = 3;
   */
  submissionEntityCode: string;
};

/**
 * Describes the message bffuser.v1.SubmissionManagementPlanKey.
 * Use `create(SubmissionManagementPlanKeySchema)` to create a new message.
 */
export const SubmissionManagementPlanKeySchema: GenMessage<SubmissionManagementPlanKey> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_model, 15);

/**
 * PlanTypeCardKind classifies a 提出管理 (submission management) dashboard
 * plan-type card. The three demand-procurement cards are mutually exclusive
 * by the representative BG's BG 区分 × its representative business master's
 * 取得目的 (submission-management.md AC-PSM-054):
 *   - DEMAND_PROCUREMENT              : 小売 × 通常
 *   - DEMAND_PROCUREMENT_SELF_WHEELING: 自己託送 (取得目的不問)
 *   - DEMAND_PROCUREMENT_BATTERY      : 小売 × 蓄電池
 * Generation-sales cards are out of scope until the generation-sales plan
 * release (map #8431) and will be added as new values.
 *
 * @generated from enum bffuser.v1.PlanTypeCardKind
 */
export enum PlanTypeCardKind {
  /**
   * @generated from enum value: PLAN_TYPE_CARD_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_KIND_DEMAND_PROCUREMENT = 1;
   */
  DEMAND_PROCUREMENT = 1,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_KIND_DEMAND_PROCUREMENT_SELF_WHEELING = 2;
   */
  DEMAND_PROCUREMENT_SELF_WHEELING = 2,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_KIND_DEMAND_PROCUREMENT_BATTERY = 3;
   */
  DEMAND_PROCUREMENT_BATTERY = 3,
}

/**
 * Describes the enum bffuser.v1.PlanTypeCardKind.
 */
export const PlanTypeCardKindSchema: GenEnum<PlanTypeCardKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 0);

/**
 * SubmissionStatusFilter is the 提出ステータスの絞込 option a card's 代表の計画
 * falls into for the viewer ("次に誰が動くか", submission-management.md §8 /
 * AC-PSM-071). Approval-pending plans depend on the viewer: ACTION_REQUIRED
 * when the viewer can approve now (or the linked approval has no approver at
 * all), WAITING otherwise (and always when the viewer is unknown).
 *
 * @generated from enum bffuser.v1.SubmissionStatusFilter
 */
export enum SubmissionStatusFilter {
  /**
   * @generated from enum value: SUBMISSION_STATUS_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 要対応: 差戻し / 作成失敗 / 送信失敗 / 不整合 (not all counterparty
   * mismatches resolved) / 承認待ち the viewer can approve now.
   *
   * @generated from enum value: SUBMISSION_STATUS_FILTER_ACTION_REQUIRED = 1;
   */
  ACTION_REQUIRED = 1,

  /**
   * 未提出: status 未提出 only (GENERATED / EDITING).
   *
   * @generated from enum value: SUBMISSION_STATUS_FILTER_UNSUBMITTED = 2;
   */
  UNSUBMITTED = 2,

  /**
   * 待ち: 作成中 / 処理中 / 承認待ち the viewer cannot approve now.
   *
   * @generated from enum value: SUBMISSION_STATUS_FILTER_WAITING = 3;
   */
  WAITING = 3,

  /**
   * 提出済: 提出済 / 受領済 / 不整合 with every counterparty mismatch resolved.
   *
   * @generated from enum value: SUBMISSION_STATUS_FILTER_SUBMITTED = 4;
   */
  SUBMITTED = 4,

  /**
   * The 代表の計画 has no plan submission on the target date yet: shown only
   * under 「すべて」 and not counted in any option.
   *
   * @generated from enum value: SUBMISSION_STATUS_FILTER_NOT_CREATED = 5;
   */
  NOT_CREATED = 5,
}

/**
 * Describes the enum bffuser.v1.SubmissionStatusFilter.
 */
export const SubmissionStatusFilterSchema: GenEnum<SubmissionStatusFilter> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 1);

/**
 * PlanTypeCardPartnerKind classifies a counterparty card.
 *
 * @generated from enum bffuser.v1.PlanTypeCardPartnerKind
 */
export enum PlanTypeCardPartnerKind {
  /**
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * JEPX スポット (JSPT3).
   *
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_KIND_JEPX_SPOT = 1;
   */
  JEPX_SPOT = 1,

  /**
   * JEPX 時間前 (J1HR3).
   *
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_KIND_JEPX_INTRADAY = 2;
   */
  JEPX_INTRADAY = 2,

  /**
   * 自社内 code of the demand-procurement plan master (is_internal).
   *
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_KIND_INTERNAL = 3;
   */
  INTERNAL = 3,

  /**
   * Other company: a trading-contract counterparty, or a non-internal master
   * code of a self-wheeling / battery card.
   *
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_KIND_COUNTERPARTY = 4;
   */
  COUNTERPARTY = 4,
}

/**
 * Describes the enum bffuser.v1.PlanTypeCardPartnerKind.
 */
export const PlanTypeCardPartnerKindSchema: GenEnum<PlanTypeCardPartnerKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 2);

/**
 * PlanTypeCardPartnerSubmissionState is the submission state (提出状態) of a
 * counterparty card.
 *
 * @generated from enum bffuser.v1.PlanTypeCardPartnerSubmissionState
 */
export enum PlanTypeCardPartnerSubmissionState {
  /**
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_SUBMISSION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 一致: OCCTO-registered and no mismatch for this counterparty.
   *
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_SUBMISSION_STATE_MATCHED = 1;
   */
  MATCHED = 1,

  /**
   * 不整合: at least one mismatch for this counterparty.
   *
   * @generated from enum value: PLAN_TYPE_CARD_PARTNER_SUBMISSION_STATE_MISMATCH = 2;
   */
  MISMATCH = 2,
}

/**
 * Describes the enum bffuser.v1.PlanTypeCardPartnerSubmissionState.
 */
export const PlanTypeCardPartnerSubmissionStateSchema: GenEnum<PlanTypeCardPartnerSubmissionState> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 3);

/**
 * PlanTypeCardMismatchKind classifies a mismatch shown on a counterparty card
 * (plan-common.md 不整合検出). Only 取引相手間ミスマッチ is shown on a counterparty
 * card: 計画内不整合 is PlanTypeCardSubmissionSummary.has_internal_inconsistency
 * (AC-PSM-077) and 計画間不整合 belongs to the plan-type card (#9599).
 *
 * @generated from enum bffuser.v1.PlanTypeCardMismatchKind
 */
export enum PlanTypeCardMismatchKind {
  /**
   * @generated from enum value: PLAN_TYPE_CARD_MISMATCH_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 取引相手間ミスマッチ, from an OCCTO inconsistency notice (0251).
   *
   * @generated from enum value: PLAN_TYPE_CARD_MISMATCH_KIND_COUNTERPARTY = 1;
   */
  COUNTERPARTY = 1,
}

/**
 * Describes the enum bffuser.v1.PlanTypeCardMismatchKind.
 */
export const PlanTypeCardMismatchKindSchema: GenEnum<PlanTypeCardMismatchKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 4);

/**
 * PlanTypeCardProgressStage is the card's main badge (主バッジ): the least
 * progressed stage among the card's representative plan submissions
 * (plan-common.md §カード UI 表現). GENERATED / EDITING / REJECTED /
 * GENERATION_FAILED / SUBMIT_FAILED / SEND_FAILED and "no plan submission yet"
 * fold into UNSUBMITTED; INCONSISTENT folds into ACCEPTED (surfaced separately
 * via has_inconsistent). UNSPECIFIED only when the summary's
 * no_submission_record is true (AC-PSM-078: no main badge). Wire values are
 * ordered from least to most progressed.
 *
 * @generated from enum bffuser.v1.PlanTypeCardProgressStage
 */
export enum PlanTypeCardProgressStage {
  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_GENERATING = 1;
   */
  GENERATING = 1,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_UNSUBMITTED = 2;
   */
  UNSUBMITTED = 2,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_APPROVAL_PENDING = 3;
   */
  APPROVAL_PENDING = 3,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_SUBMITTING = 4;
   */
  SUBMITTING = 4,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_SUBMITTED = 5;
   */
  SUBMITTED = 5,

  /**
   * @generated from enum value: PLAN_TYPE_CARD_PROGRESS_STAGE_ACCEPTED = 6;
   */
  ACCEPTED = 6,
}

/**
 * Describes the enum bffuser.v1.PlanTypeCardProgressStage.
 */
export const PlanTypeCardProgressStageSchema: GenEnum<PlanTypeCardProgressStage> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 5);

/**
 * PlanTypeCardAttention is how strongly the whole card header is emphasized
 * (submission-management.md §2: 差戻し / 作成失敗 / 不整合 / 送信失敗).
 *
 * @generated from enum bffuser.v1.PlanTypeCardAttention
 */
export enum PlanTypeCardAttention {
  /**
   * No emphasis.
   *
   * @generated from enum value: PLAN_TYPE_CARD_ATTENTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * At least one plan record has an unresolved counterparty mismatch (see
   * SubmissionDashboardTabIndicator.counterparty_mismatch_plan_count) and no
   * representative plan submission is in an error status. A plan whose
   * mismatches are all resolved keeps has_inconsistent but is not emphasized.
   *
   * @generated from enum value: PLAN_TYPE_CARD_ATTENTION_WARNING = 1;
   */
  WARNING = 1,

  /**
   * At least one representative plan submission is REJECTED /
   * GENERATION_FAILED / SUBMIT_FAILED / SEND_FAILED.
   *
   * @generated from enum value: PLAN_TYPE_CARD_ATTENTION_ERROR = 2;
   */
  ERROR = 2,
}

/**
 * Describes the enum bffuser.v1.PlanTypeCardAttention.
 */
export const PlanTypeCardAttentionSchema: GenEnum<PlanTypeCardAttention> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 6);

/**
 * PlanCounterpartyMismatchSide is the side of the plan a counterparty is on.
 *
 * @generated from enum bffuser.v1.PlanCounterpartyMismatchSide
 */
export enum PlanCounterpartyMismatchSide {
  /**
   * @generated from enum value: PLAN_COUNTERPARTY_MISMATCH_SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 調達側.
   *
   * @generated from enum value: PLAN_COUNTERPARTY_MISMATCH_SIDE_PROCUREMENT = 1;
   */
  PROCUREMENT = 1,

  /**
   * 販売側.
   *
   * @generated from enum value: PLAN_COUNTERPARTY_MISMATCH_SIDE_SALES = 2;
   */
  SALES = 2,
}

/**
 * Describes the enum bffuser.v1.PlanCounterpartyMismatchSide.
 */
export const PlanCounterpartyMismatchSideSchema: GenEnum<PlanCounterpartyMismatchSide> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 7);

/**
 * ResolvePlanCounterpartyMismatchResult is the outcome of a resolve call.
 *
 * @generated from enum bffuser.v1.ResolvePlanCounterpartyMismatchResult
 */
export enum ResolvePlanCounterpartyMismatchResult {
  /**
   * @generated from enum value: RESOLVE_PLAN_COUNTERPARTY_MISMATCH_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Recorded: show the success toast.
   *
   * @generated from enum value: RESOLVE_PLAN_COUNTERPARTY_MISMATCH_RESULT_RESOLVED = 1;
   */
  RESOLVED = 1,

  /**
   * Not recorded because the list changed: re-read and show the latest list
   * in the open dialog (AC-PSM-064).
   *
   * @generated from enum value: RESOLVE_PLAN_COUNTERPARTY_MISMATCH_RESULT_STALE = 2;
   */
  STALE = 2,
}

/**
 * Describes the enum bffuser.v1.ResolvePlanCounterpartyMismatchResult.
 */
export const ResolvePlanCounterpartyMismatchResultSchema: GenEnum<ResolvePlanCounterpartyMismatchResult> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_submission_management_model, 8);

